import { render } from "./ImagesPage.vue?vue&type=template&id=308cc4c2&ts=true"
import script from "./ImagesPage.vue?vue&type=script&lang=ts"
export * from "./ImagesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__